import { createGlobalStyle } from 'styled-components'

import theme from '@app/ui/theme'

const GlobalStyle = createGlobalStyle`
  html {
    font-size: 62.5%;
    box-sizing: border-box;
    height: 100%;
  }

  body {
    margin: 0;
    height: 100%;
    font-family: Inter, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: ${theme.global.colors.floralWhite};
    color: ${theme.global.colors.elemyGreen};
    font-size: ${theme.text.normal.size};
    line-height: ${theme.text.normal.height};
  }

  #root {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  main {
    flex-grow: 1;
  }
  
  p {
    margin: 0;
  }

  ul, li {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    font-style: normal;
    font-weight: 400;
  }

  a {
    text-decoration: none;
  }

  .rc-collapse-header {
    :focus {
      outline: none
    }

    // Focusing by keyboard
    :focus-visible {
      outline: auto 1px;
    }
  }
`

export default GlobalStyle
